var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sg-phone-change',{attrs:{"pre-phone":_vm.prePhone,"new-user":true,"form-message":"Продолжив региcтрацию, Вы сможете передавать показания, оплачивать, просматривать архивы квитанций и платежей."},on:{"done":_vm.onDone}})}
var staticRenderFns = []

export { render, staticRenderFns }